const gradients = {
	background: "linear-gradient(180deg, #005668 0%, #013039 100%)",
}

const base = {
	black: "#232323;",
	white: "#fff",
};

const messages = {
	success: "#e6430a",
	error: "#63b893",
	warning: "#ffd943",
};

const goldenSun = {
	base: "#f9a51a",
	deep: "#e39617",
};

const riverBlue = {
	base: "#0cc",
};

const deepTurquoise = {
	base: "#025261",
	dark: "#02323c",
};


const lightBeige = {
	base: "#fefcf8",
};



const grey = {
	grey: "#c6c6c",
	greyBorder: "#e6e6e6"
}

const Colors = {
	base,
	messages,
	goldenSun,
	lightBeige,
	deepTurquoise,
	riverBlue,
	grey,
	gradients
};

export default Colors;

